import { assertNever } from '@kofno/piper';
import { fromNullable } from 'maybeasy';
import { useMatch } from 'react-router-dom';

/**
 * The page's two sections. The route is the source of truth, so existing
 * links to /people/participants and /people/groups land on the right one.
 */
export type Segment = 'participants' | 'groups';

export const segmentPath = (segment: Segment): string => {
  switch (segment) {
    case 'participants':
      return '/people/participants';
    case 'groups':
      return '/people/groups';
    default:
      return assertNever(segment);
  }
};

export const useSegment = (): Segment =>
  fromNullable(useMatch({ path: '/people/groups', end: false }))
    .map((): Segment => 'groups')
    .getOrElseValue('participants');
